import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m6 1 .32.002.308.009.15.007.29.016.276.024c2.343.227 3.325 1.166 3.583 3.453l.015.144.023.277.02.363.004.075.008.309.002.321-.002.321-.008.308-.007.15-.017.289-.023.277c-.228 2.343-1.167 3.324-3.453 3.583l-.145.014-.277.024-.363.02-.075.003-.308.008L6 11l-.322-.002-.308-.009-.149-.007-.29-.016-.276-.023C2.312 10.715 1.33 9.776 1.072 7.49l-.015-.146-.023-.276-.02-.363-.004-.075-.008-.309L1 6.162v-.324l.002-.159.008-.308.007-.15.017-.289.023-.277C1.285 2.313 2.224 1.33 4.51 1.072l.145-.014.276-.024.364-.02.075-.003.308-.008Q5.837 1 6 1m0 4.5h-.5l-.059.003a.5.5 0 0 0 0 .994L5.5 6.5V8l.003.059a.5.5 0 0 0 .438.438L6 8.5h.5l.058-.004a.5.5 0 0 0 .438-.437L6.999 8l-.003-.059a.5.5 0 0 0-.382-.428l-.056-.01L6.5 7.5V6l-.004-.059a.5.5 0 0 0-.438-.437zM6.005 4l-.064.003a.5.5 0 0 0 0 .994L6 5l.063-.003a.5.5 0 0 0 0-.993z"
    }, null, -1)
  ])))
}
export default { render: render }